import Work9 from "../../assets/work9.png";
import Work10 from "../../assets/work10.png";
import car_showcase from "../../assets/car_showcase.png";

export const projectsData = [
	{
		id: 1,
		image: Work9,
		title: "E-commerce",
		category: "web",
		url: "https://next-ecommerce-one-delta.vercel.app",
		description: "Universal debit card code: 424242...",
	},
	{
		id: 2,
		image: Work10,
		title: "Social-app",
		category: "web",
		url: "https://social-app-beta-lac.vercel.app",
		description: "Login: adam || Password: 1234",
	},
	{
		id: 3,
		image: car_showcase,
		title: "CarHub - cars showcase",
		category: "web",
		url: "https://cars-showcase-smoky.vercel.app/",
		description: "",
	},
];

export const projectNav = [
	{
		name: "all",
	},
	{
		name: "web",
	},
	{
		name: "app",
	},
];
